var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 21.4583L15.4997 24.625M15.4997 24.625L18.6663 21.4583M15.4997 24.625V17.5M21.833 21.2547C22.8 20.4561 23.4163 19.248 23.4163 17.8958C23.4163 15.4911 21.4669 13.5417 19.0622 13.5417C18.8892 13.5417 18.7273 13.4514 18.6395 13.3024C17.6071 11.5505 15.7011 10.375 13.5205 10.375C10.2413 10.375 7.58301 13.0333 7.58301 16.3125C7.58301 17.9482 8.2444 19.4294 9.31434 20.5032",
    stroke: "#969CA7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.629bc06eb6dab63cc59d152468688d75.svg";
export { ForwardRef as ReactComponent };